const extractPlainText = (richTextRaw, maxLength = 120) => {
  if (!richTextRaw) return ""
  try {
    const parsed = JSON.parse(richTextRaw)
    const extractText = (node) => {
      if (node.nodeType === "text") {
        return node.value || ""
      }
      if (node.content && Array.isArray(node.content)) {
        return node.content.map(extractText).join("")
      }
      return ""
    }
    const text = extractText(parsed).trim()
    if (!maxLength || text.length <= maxLength) return text
    return `${text.substring(0, maxLength)}...`
  } catch (e) {
    return ""
  }
}

export default extractPlainText
export { extractPlainText }
